(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esim-product-v14"] && !Shopify.designMode) return;
  try {
    
  document.body.classList.add('has-esim-v14');
  document.querySelectorAll('[data-esim-v14]').forEach((root) => {
    const tocLinks = [...root.querySelectorAll('.esim-v14__toc a')];
    const sections = tocLinks.map((link) => root.querySelector(link.getAttribute('href'))).filter(Boolean);
    const syncToc = () => {
      let active = sections[0];
      sections.forEach((section) => { if (section.getBoundingClientRect().top <= 130) active = section; });
      tocLinks.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${active?.id}`));
    };
    window.addEventListener('scroll', syncToc, { passive: true });
    syncToc();

    const figures = [...root.querySelectorAll('[data-v14-image]')];
    const thumbs = [...root.querySelectorAll('[data-v14-thumb]')];
    const zoom = root.querySelector('[data-v14-zoom]');
    const zoomPanels = [...root.querySelectorAll('[data-v14-zoom-panel]')];
    const zoomCount = root.querySelector('[data-v14-zoom-count]');
    let activeImageIndex = Math.max(0, figures.findIndex((item) => item.classList.contains('is-active')));
    let touchStartX = 0;
    const selectImage = (index) => {
      if (!figures.length) return;
      activeImageIndex = (index + figures.length) % figures.length;
      figures.forEach((item, position) => item.classList.toggle('is-active', position === activeImageIndex));
      thumbs.forEach((item, position) => { item.classList.toggle('is-active', position === activeImageIndex); item.setAttribute('aria-pressed', String(position === activeImageIndex)); });
      zoomPanels.forEach((item, position) => { item.hidden = position !== activeImageIndex; });
      if (zoomCount) zoomCount.textContent = `${activeImageIndex + 1} / ${figures.length}`;
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => selectImage(Number(thumb.dataset.v14Thumb))));
    root.querySelector('[data-v14-zoom-open]')?.addEventListener('click', () => { selectImage(activeImageIndex); zoom?.showModal(); });
    root.querySelector('[data-v14-zoom-prev]')?.addEventListener('click', () => selectImage(activeImageIndex - 1));
    root.querySelector('[data-v14-zoom-next]')?.addEventListener('click', () => selectImage(activeImageIndex + 1));
    root.querySelector('[data-v14-zoom-close]')?.addEventListener('click', () => zoom?.close());
    zoom?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') selectImage(activeImageIndex - 1);
      if (event.key === 'ArrowRight') selectImage(activeImageIndex + 1);
    });
    zoom?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    zoom?.addEventListener('touchend', (event) => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 45) return;
      selectImage(activeImageIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    zoom?.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });
    selectImage(activeImageIndex);

    const variants = [...root.querySelectorAll('[data-v14-variant]')];
    const price = root.querySelector('[data-v14-price]');
    const mobilePrice = root.querySelector('[data-v14-mobile-price]');
    const btnPrice = root.querySelector('[data-v14-btn-price]');
    const includedCopy = root.querySelector('[data-v14-included-copy]');
    const summaries = [...root.querySelectorAll('[data-v14-summary]')];
    const planCards = [...root.querySelectorAll('[data-v14-plan-card]')];
    const fitPanels = [...root.querySelectorAll('[data-v14-fit-panel]')];
    const callPanels = [...root.querySelectorAll('[data-v14-call-panel]')];
    const destinationPanels = [...root.querySelectorAll('[data-v14-destinations]')];
    const selectPlanButtons = [...root.querySelectorAll('[data-v14-select-plan]')];
    const syncVariant = (input, updateUrl = true) => {
      variants.forEach((item) => item.closest('label')?.classList.toggle('is-active', item === input));
      if (price) price.textContent = input.dataset.price;
      if (mobilePrice) mobilePrice.textContent = input.dataset.price;
      /* 文档 §2.3 的主行动是「Buy now · 价格占位符」，所以按钮里那一格也要跟着档位走。
         ★ 本块的注释里不能出现 Liquid 语法（双花括号或百分号标签）——
           theme check 会报 StaticStylesheetAndJavascriptTags（error 级），
           而那一条会把「11 条已解释告警、0 error」这个基线信号搞浑。
           这一条我连栽两次：先是写了价格占位符，改完又在解释里写了标签名。
         ★ 只换 span 的 textContent，不要动按钮的 innerHTML —— 那会把
           name="return_to" 之外的结构重建一遍，也会丢掉分隔符前后的空白。 */
      if (btnPrice) btnPrice.textContent = input.dataset.price;
      if (includedCopy) {
        includedCopy.textContent = input.dataset.includedCopy || "";
        includedCopy.hidden = !input.dataset.includedCopy;
      }
      summaries.forEach((item) => { item.hidden = item.dataset.v14Summary !== input.value; });
      planCards.forEach((card) => { const active = card.dataset.v14PlanCard === input.value; card.classList.toggle('is-active', active); card.querySelector('[data-v14-card-status]')?.toggleAttribute('hidden', !active); });
      fitPanels.forEach((panel) => { panel.hidden = panel.dataset.v14FitPanel !== input.value; });
      callPanels.forEach((panel) => { panel.hidden = panel.dataset.v14CallPanel !== input.value; });
      destinationPanels.forEach((panel) => { panel.hidden = panel.dataset.v14Destinations !== input.value; });
      if (updateUrl && window.history?.replaceState) { const url = new URL(window.location.href); url.searchParams.set('variant', input.value); window.history.replaceState({}, '', url); }
    };
    variants.forEach((input) => input.addEventListener('change', () => syncVariant(input)));
    selectPlanButtons.forEach((button) => button.addEventListener('click', () => { const input = variants.find((item) => item.value === button.dataset.v14SelectPlan); if (!input) return; input.checked = true; syncVariant(input); root.querySelector('.esim-v14__buy-card')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }));
    const checkedVariant = variants.find((input) => input.checked);
    if (checkedVariant) syncVariant(checkedVariant, false);

    const consents = Array.from(root.querySelectorAll('[data-v14-consent]'));
    const form = root.querySelector('.esim-v14__form');
    const error = form?.querySelector('[role="alert"]');
    const allConsentsAccepted = () => consents.length > 0 && consents.every((consent) => consent.checked);
    // 只管错误提示的显隐，不再 disable 按钮：
    // ① 默认灰掉主行动会抹平「直接结账 / 加入购物车」的主次层级；
    // ② 门本来有两道 —— checkbox 的原生 required + 下面那个 submit 拦截。
    const syncConsent = () => {
      if (allConsentsAccepted() && error) error.hidden = true;
    };
    consents.forEach((consent) => consent.addEventListener('change', syncConsent));
    form?.addEventListener('submit', (event) => {
      if (!allConsentsAccepted()) {
        event.preventDefault();
        if (error) error.hidden = false;
        consents.find((consent) => !consent.checked)?.focus();
      }
    });
    syncConsent();

    const backToTop = root.querySelector('[data-v14-back-to-top]');
    if (backToTop) {
      const syncBackToTop = () => {
        const shouldShow = root.getBoundingClientRect().top < -Math.max(420, window.innerHeight * 0.75);
        backToTop.classList.toggle('is-visible', shouldShow);
        backToTop.setAttribute('aria-hidden', String(!shouldShow));
        backToTop.tabIndex = shouldShow ? 0 : -1;
      };
      window.addEventListener('scroll', syncBackToTop, { passive: true });
      window.addEventListener('resize', syncBackToTop, { passive: true });
      syncBackToTop();
    }

    const mobileBuy = root.querySelector('[data-v14-mobile-buy]');
    const checkout = root.querySelector('.esim-v14__checkout');
    if (mobileBuy && checkout) {
      let checkoutIsVisible = false;
      const syncMobileBuy = () => {
        const shouldShow = window.innerWidth <= 990 && !checkoutIsVisible;
        mobileBuy.classList.toggle('is-visible', shouldShow);
        mobileBuy.setAttribute('aria-hidden', String(!shouldShow));
      };
      if ('IntersectionObserver' in window) {
        const buyObserver = new IntersectionObserver(([entry]) => {
          checkoutIsVisible = entry.isIntersecting;
          syncMobileBuy();
        }, { threshold: 0.2 });
        buyObserver.observe(checkout);
      } else {
        syncMobileBuy();
      }
      window.addEventListener('resize', syncMobileBuy, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taro-collection-plans"] && !Shopify.designMode) return;
  try {
    
  // 筛选 + 计数 + 方案行展开。无 JS 时：列表完整、汇总行完整、搜索框仍能提交，
  // 只有「展开方案」和实时筛选失效 —— 增强而非必需品。
  (function () {
    document.querySelectorAll('[data-taro-plans]').forEach(function (root) {
      var grid = root.querySelector('[data-taro-plans-grid]');
      var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-taro-plan]')) : [];
      var search = root.querySelector('[data-taro-plans-search]');
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-taro-plans-filter]'));
      var countEl = root.querySelector('[data-taro-plans-count]');
      var clearEl = root.querySelector('[data-taro-plans-clear]');
      var emptyEl = root.querySelector('[data-taro-plans-empty]');
      var tmpl = countEl ? (countEl.getAttribute('data-count-template') || countEl.textContent.trim()) : '';
      var countSearchTmpl = root.getAttribute('data-count-search-template') || '%shown% products cover “%query%”';
      var countSearchOneTmpl = root.getAttribute('data-count-search-one-template') || '1 product covers “%query%”';
      var coversTmpl = root.getAttribute('data-covers-template') || 'Covers %country%';

      var EMPTY_TEXT = {
        filters: root.getAttribute('data-empty-filters') || '',
        search: root.getAttribute('data-empty-search') || '',
        both: root.getAttribute('data-empty-both') || '',
      };
      function showSearchMatch(li, query) {
        var el = li.querySelector('[data-taro-plan-match]');
        if (!el) return;
        if (!query) { el.textContent = ''; el.hidden = true; return; }
        el.textContent = coversTmpl.replace('%country%', query);
        el.hidden = false;
      }

      function apply() {
        var query = (search && search.value || '').trim();
        var q = query.toLowerCase();
        var want = filters.filter(function (f) { return f.checked; }).map(function (f) { return f.value; });
        var shown = 0;
        items.forEach(function (li) {
          var hay = li.getAttribute('data-destination') || '';
          // token 两侧留空格，避免 'sms' 命中 'sms-two-way'
          var caps = ' ' + (li.getAttribute('data-capabilities') || '') + ' ';
          var ok = (!q || hay.indexOf(q) !== -1) && want.every(function (k) {
            return caps.indexOf(' ' + k + ' ') !== -1;
          });
          li.hidden = !ok;
          if (ok) {
            shown++;
            showSearchMatch(li, query);
          } else {
            showSearchMatch(li, '');
          }
        });
        if (countEl && tmpl) {
          countEl.textContent = query
            ? (shown === 1 ? countSearchOneTmpl : countSearchTmpl).replace('%shown%', String(shown)).replace('%query%', query)
            : tmpl.replace('__SHOWN__', String(shown));
        }
        if (clearEl) clearEl.hidden = !(query || want.length);
        if (emptyEl) {
          emptyEl.hidden = shown !== 0;
          // 空状态文案要对得上成因。原来只有一句「…those filters. Clear a filter…」，
          // 用户只搜了个国家、一个筛选都没勾时也照样叫他去清筛选（实测搜 japan 就是这样）。
          var txt = emptyEl.querySelector('[data-taro-empty-text]');
          if (txt && shown === 0) {
            var which = q && want.length ? 'both' : q ? 'search' : 'filters';
            if (EMPTY_TEXT[which]) txt.textContent = EMPTY_TEXT[which];
          }
        }
        syncUrl();
      }

      // ── URL 状态：destination + caps ────────────────────────────────
      //
      // 目录里 60 个欧洲国家链接靠 ?destination= 落到这一页，这部分本来就有。
      // 新增的是**筛选状态也进 URL** —— 筛完的视图此前不可分享、刷新即丢。
      //
      // 用 replaceState 不用 pushState：勾选筛选不该在浏览器历史里堆条目，
      // 否则返回键要按七次才离开这一页。
      //
      // 注意 section 的静态 JS 块里**不渲染 Liquid**，所以这一带只能用 JS 注释。
      // 我在这里写过 Liquid 注释，标签被原样输出成 JS、整个 section 的脚本直接挂掉
      // （连原有的 destination 回填都不工作了），而 theme check 照样通过 ——
      // 它只查 Liquid 变量不查标签。自查脚本 scripts/check-static-blocks.mjs 补了这一半。
      function syncUrl() {
        try {
          var p = new URLSearchParams(window.location.search);
          var q = (search && search.value || '').trim();
          if (q) p.set('destination', q); else p.delete('destination');
          var on = filters.filter(function (f) { return f.checked; }).map(function (f) { return f.value; });
          if (on.length) p.set('caps', on.join(',')); else p.delete('caps');
          var qs = p.toString();
          window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
        } catch (e) {}
      }

      if (search) search.addEventListener('input', apply);
      filters.forEach(function (f) { f.addEventListener('change', apply); });
      if (clearEl) {
        clearEl.addEventListener('click', function () {
          if (search) search.value = '';
          filters.forEach(function (f) { f.checked = false; });
          apply();
          if (search) search.focus();
        });
      }

      // 设备自查：按 UA 把对应平台那一条默认展开。**只是展开，不是判定** ——
      // 浏览器读不到 eSIM 能力，三条路径始终都在。六家同行没人做这一步，
      // 但它没有任何准确性主张，纯粹省用户一次点击。
      try {
        var dc = document.querySelector('[data-taro-device-check]');
        if (dc) {
          var ua = navigator.userAgent || '';
          var want = /iPhone|iPad|iPod/i.test(ua) ? 'ios'
                   : /SM-|Samsung/i.test(ua) ? 'samsung'
                   : /Android/i.test(ua) ? 'android'
                   : null;
          if (want) {
            var hit = dc.querySelector('[data-taro-device-path="' + want + '"]');
            if (hit) hit.setAttribute('open', '');
          }
        }
      } catch (e) {}

      // 进场时把 URL 状态灌回控件，再跑第一次 apply()。
      // caps 是 2026-08-06 新增的；destination 早就在用（目录 60 个国家链接靠它）。
      try {
        var params = new URLSearchParams(window.location.search);
        var v = params.get('destination');
        if (v && search) search.value = v;
        var caps = (params.get('caps') || '').split(',').filter(Boolean);
        if (caps.length) {
          filters.forEach(function (f) { if (caps.indexOf(f.value) !== -1) f.checked = true; });
        }
      } catch (e) {}

      // 表单的 checkbox 没有 name，GET 提交带不走它们；而有 JS 时提交本身也没有
      // 意义（筛选是客户端的）。所以拦掉提交，只重算 + 更新 URL。
      // 无 JS 时提交照旧走原生 GET —— 那时筛选本来就不工作，属既有的优雅降级。
      var form = root.querySelector('[data-taro-plans-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          apply();
        });
      }

      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taro-header"]) return;
  try {
    
  if (!window.taroMobileNavigationReady) {
    window.taroMobileNavigationReady = true;

    document.querySelectorAll('.taro-header__mobile').forEach((menu) => {
      const control = menu.querySelector('summary');
      const syncLabel = () => {
        control?.setAttribute('aria-label', menu.open ? control.dataset.closeLabel : control.dataset.openLabel);
      };
      menu.addEventListener('toggle', syncLabel);
      syncLabel();
    });

    /* 桌面下拉（`.taro-header__group`）此前不在任何处理器里 —— 于是点开一个
       再点另一个，前一个不收，两块面板同时展开。原生 `<details>` 没有分组语义
       （`name` 属性只在新版浏览器里有），而点外面收与 Esc 收本来就要 JS，
       所以三件事用同一套机制，不混用两种。 */
    document.querySelectorAll('.taro-header__group').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        document.querySelectorAll('.taro-header__group[open]').forEach((other) => {
          if (other !== group) other.removeAttribute('open');
        });
      });
    });

    /* 锚点滚动偏移。原来算在 `sections/taro-section-rail.liquid` 里，
       而那一节 2026-08-20 从首页撤掉后就不渲染了 —— 全站 `#compare` /
       `#faq` 之类的链接会落到粘顶头部底下。偏移属于**遮住内容的那个元素**，
       也就是头部，所以搬到这里；第二排存在时把它的高度加进去。
       变量名保持 `--taro-rail-*`：多个 section 的 CSS 在读它。 */
    const syncAnchorOffset = () => {
      const bar = document.querySelector('header.taro-header') || document.querySelector('.taro-header-section');
      if (!bar) return;
      const stickyTop = parseFloat(getComputedStyle(bar).top) || 0;
      const visibleBottom = bar.getBoundingClientRect().height + stickyTop;
      if (!(visibleBottom > 0)) return;
      const rail = document.querySelector('[data-taro-rail]');
      const railHeight = rail ? rail.getBoundingClientRect().height : 0;
      const root = document.documentElement.style;
      root.setProperty('--taro-rail-top', Math.round(visibleBottom) + 'px');
      root.setProperty('--taro-rail-stack', Math.round(visibleBottom + railHeight + 8) + 'px');
    };
    syncAnchorOffset();
    window.addEventListener('resize', syncAnchorOffset);
    /* 字体晚到会改变公告条行高，所以字体就绪后再量一次 */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAnchorOffset);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      document.querySelectorAll('.taro-header__mobile[open]').forEach((menu) => {
        const selectedLink = event.target.closest('.taro-header__mobile a');
        if (!menu.contains(event.target) || selectedLink) {
          menu.removeAttribute('open');
        }
      });

      document.querySelectorAll('.taro-header__localization[open]').forEach((preferences) => {
        if (!preferences.contains(event.target)) preferences.removeAttribute('open');
      });

      document.querySelectorAll('.taro-header__group[open]').forEach((group) => {
        const followedLink = event.target.closest('.taro-header__group a');
        if (!group.contains(event.target) || followedLink) group.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const menu = document.querySelector('.taro-header__mobile[open]');
      if (menu) {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
        return;
      }

      const group = document.querySelector('.taro-header__group[open]');
      if (group) {
        group.removeAttribute('open');
        group.querySelector('summary')?.focus();
        return;
      }

      const preferences = document.querySelector('.taro-header__localization[open]');
      if (!preferences) return;
      preferences.removeAttribute('open');
      preferences.querySelector('summary')?.focus();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taro-home-plans"] && !Shopify.designMode) return;
  try {
    
  /* 地区筛选。纯客户端，服务端已渲染全部 14 张卡（无 JS 时全部可见可点）。
     ★ section 的 JS 只在**该 section 实际渲染的页面**上生效
       —— Shopify 按「本页渲染了哪些 section」决定 bundle 里哪些 JS 跑。
       所以这段不会在别的页面白跑。 */
  (() => {
    const root = document.querySelector('[data-taro-shelf]');
    if (!root) return;
    const chips = [...root.querySelectorAll('[data-taro-region]')];
    const cards = [...root.querySelectorAll('[data-taro-card]')];
    const shown = root.querySelector('[data-taro-shelf-shown]');
    const empty = root.querySelector('[data-taro-shelf-empty]');
    if (!chips.length || !cards.length) return;

    const apply = (region) => {
      let n = 0;
      for (const card of cards) {
        const match = region === 'all' || card.dataset.region === region;
        /* 用 hidden 属性而不是 style.display —— 主题的 reset 里有
           `[hidden]{display:none!important}`，而 hidden 同时把卡片从
           无障碍树里摘掉（读屏不会念出被筛掉的卡）。 */
        card.hidden = !match;
        if (match) n++;
      }
      if (shown) shown.textContent = String(n);
      if (empty) empty.hidden = n > 0;
    };

    for (const chip of chips) {
      chip.addEventListener('click', () => {
        for (const c of chips) {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        apply(chip.dataset.taroRegion);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taro-information-page"] && !Shopify.designMode) return;
  try {
    
  /* 页内小节栏的「当前小节」高亮（2026-09-03）。

     为什么不复用 sections/taro-section-rail.liquid 那一份：见本文件顶部
     小节栏那段注释里的实测记录 —— 代码在 bundle 里但不执行。

     用 IntersectionObserver 而不是 scroll 监听：后者在移动端惯性滚动时掉帧，
     而这条栏在移动端是常驻的。 */
  (function () {
    if (window.taroInfoRailReady) return;
    var rail = document.querySelector('.taro-info-rail');
    if (!rail || !('IntersectionObserver' in window)) return;

    var links = Array.prototype.slice.call(rail.querySelectorAll('[data-taro-rail-link]'));
    var targets = links
      .map(function (a) {
        var el = document.getElementById(a.getAttribute('data-taro-rail-link'));
        return el ? { id: el.id, el: el, link: a } : null;
      })
      .filter(Boolean);
    if (!targets.length) return;
    window.taroInfoRailReady = true;

    var visible = Object.create(null);
    var io = null;

    function paint() {
      var current = null;
      for (var i = 0; i < targets.length; i++) {
        if (visible[targets[i].id]) current = targets[i];
      }
      /* 没有任何一节落在判定带里（例如还在首屏 hero 上）时**不高亮任何一项** ——
         硬留上一个是假高亮，比不高亮更误导。 */
      links.forEach(function (a) {
        var on = !!current && a === current.link;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    /* 判定带的上边界要排除「粘顶头部 + 本栏」那一段，否则某节刚进入被遮住的
       区域就已经算「当前」，高亮会早一节。这个值与锚点偏移同一个来源
       （--taro-rail-stack，由头部的 JS 现量），所以要在它就绪之后再建 observer，
       并在 resize 时重建 —— 公告条换行会改变头部高度。 */
    function build() {
      if (io) io.disconnect();
      visible = Object.create(null);
      var stack =
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--taro-rail-stack')) || 166;
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) visible[e.target.id] = true;
            else delete visible[e.target.id];
          });
          paint();
        },
        { rootMargin: '-' + Math.round(stack) + 'px 0px -55% 0px', threshold: 0 }
      );
      targets.forEach(function (t) {
        io.observe(t.el);
      });
    }

    build();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });

    /* 点了按钮之后立刻给出反馈：原生锚点跳转不触发 scroll 事件序列，
       IntersectionObserver 要等一帧才更新，中间那一下会显得没反应。 */
    rail.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-taro-rail-link]') : null;
      if (!link) return;
      links.forEach(function (a) {
        a.classList.toggle('is-active', a === link);
      });
    });
  })();
/* FAQ 药丸手风琴：一次只开一个。
       这两页（why-taro / how-taro-works）的 FAQ 在 page.content 里，
       加不了 name 属性，所以在这里现设。长相由 taro-v3-base.css 的
       .taro-page-part[id$="-faq"] 分部给，与 4 处 section 完全同一套。 */
    var faqParts = document.querySelectorAll('.taro-page-part[id$="-faq"]');
    for (var fi = 0; fi < faqParts.length; fi++) {
      var items = faqParts[fi].querySelectorAll(':scope > details');
      for (var ii = 0; ii < items.length; ii++) {
        items[ii].name = 'taro-faq-' + faqParts[fi].id;
        if (ii === 0) items[ii].open = true;
      }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taro-section-rail"] && !Shopify.designMode) return;
  try {
    
  // 高亮当前小节。IntersectionObserver 而不是 scroll 监听 ——
  // 后者在移动端惯性滚动时会掉帧，而这条栏在移动端是常驻的。
  (function () {
    var rail = document.querySelector('[data-taro-rail]');
    if (!rail) return;

    // 粘顶偏移已搬到 sections/taro-header.liquid（2026-08-20）。
    // 原因：这一节从首页撤掉后就不渲染，而 `--taro-rail-stack` 是全站锚点的
    // 唯一偏移来源 —— 留在这里等于「第二排一撤，所有锚点全落到头部底下」。
    // 头部那份会在这一节存在时把它的高度加进去，所以重新启用不用改代码。

    if (!('IntersectionObserver' in window)) return;

    var links = Array.prototype.slice.call(rail.querySelectorAll('[data-taro-rail-link]'));
    var targets = links
      .map(function (a) {
        var el = document.getElementById(a.getAttribute('data-taro-rail-link'));
        return el ? { id: el.id, el: el, link: a } : null;
      })
      .filter(Boolean);
    if (!targets.length) return;

    var visible = Object.create(null);

    function paint() {
      var current = null;
      for (var i = 0; i < targets.length; i++) {
        if (visible[targets[i].id]) current = targets[i];
      }
      // 没有任何一节在视口内（例如还在首屏）时不高亮任何一项，
      // 而不是硬留上一个 —— 假高亮比不高亮更误导。
      links.forEach(function (a) {
        a.classList.toggle('is-active', !!current && a === current.link);
        if (!!current && a === current.link) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    // 上边界排除掉粘顶头部 + 本栏那一段，否则「进入视口」在被遮住的区域里
    // 就已经触发，高亮会早一节。与 scroll-margin 同一个来源。
    var stackPx =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--taro-rail-stack')) || 172;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible[e.target.id] = true;
          else delete visible[e.target.id];
        });
        paint();
      },
      { rootMargin: '-' + Math.round(stackPx) + 'px 0px -55% 0px', threshold: 0 }
    );

    targets.forEach(function (t) {
      // taro-anchor 是 visibility:hidden 的空 span，本身没有高度，
      // 观察它等于观察一条线 —— 配合 rootMargin 下边界 -55% 才有意义：
      // 那条线进入「视口上部 45%」时才算当前小节。
      io.observe(t.el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
